import GSObject from "./GSObject";

// A GSObject capable of having 2 parents (with one being the main (real) parent).
// For example: Attaching visuals to a Blok in the game from within the GameKit class.
// The object behaves like a GSObject within it's normal GSO structure (through the stepparent), 
// but will not be destroyed if the stepParent asks for it. Instead the realParent can be used to handle the situation.
// There should never be 2 parasites subsequently in a branch.
// Step parent is optional.
export default class GSOParasite extends GSObject  {
    constructor(realParent, stepParent) {
        super(stepParent);
        this._realParent = realParent;

        if (stepParent)
            this.onAttach();
    }

    detachFromStepParent() {
        if (this._gsoParent) {
            this._gsoDestroyVisuals();
            this._gsoDestroyBody();
            const i = this._gsoParent._gsoChildren.indexOf(this);
            if (i >= 0)
                this._gsoParent._gsoChildren.splice(i, 1);
            this._gsoParent = null;
            this.onDetach();
        }
    }

    attachToStepParent(newStepParent) {
        if (this._gsoParent)
            this.detachFromStepParent();
        this._gsoParent = newStepParent;
        this._gsoParent._gsoChildren.push(this);
        if (this._gsoParent) {
            this.onAttach();
            if (this._gsoParent._hasVisuals)
                this._gsoCreateVisuals();
            if (this._gsoParent._hasBody)
                this._gsoCreateBody();
        }
    }

    getAttachedStepParent() {
        if (!this._gsoParent)
            throw new Error("No step parent is attached to this GSOParasite.");
        return this._gsoParent;
    }

    // (Don't call this to destroy this parasite, use "parasiteDestroy" instead). Detaches the GSO from the step parent.
    destroy() {
        this.detachFromStepParent();
        this.onDetachedThroughDestroy();
    }

    // Destroys this GSO and its children (like the GSObject implementation of "destroy").
    parasiteDestroy() {
        this._destroyImplementation();
    }
    
    // ////==============//////
    // @@// OVERRIDEABLE //@@//
    // ////==============//////

    onDetachedThroughDestroy() { }

    onDetach() { }

    onAttach() { }
}